module.exports = __webpack_public_path__ + "static/media/logo.cb261e9a.png";